import useSystemTrackerHook from "./useSystemTrackerHook";

const useIsMergeHook = () => {
  const {
    systemTrackerQuery: { data },
  } = useSystemTrackerHook();
  return data?.use_formulas ?? false;
};

export default useIsMergeHook;
